// Added by Sejune Oh on 2019-02-15
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { NodeElementProps } from '@/stores/mgmt/node'

// TODO > Content별로 별도 Define 파일로 정리해야함.
export * from './auditLogDefine'
export * from './apsDefine'
export * from './dataStorageDefine'
export * from './dicomPeerDefine'
export * from './legacyEventDefine'
export * from './notificationsDefine'
export * from './nodeDefine'
export * from './screenSharingDefine'
export * from './taskDefine'
export * from './userDefine'
export * from './siteConfigDefine'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 *  Contents
 *
 *  [01] Constants
 *  [02] Types
 *  [03] Interfaces
 *  [04] Event Interfaces
 *  [05] Enums
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [01] Constants

// # Router path
export const routerPath = {
  MAIN: '',
  WORKLIST: 'app',
  LOGIN: 'login',
  LOGOUT: 'logout',
  MGMT: 'mgmt',
  DASHBOARD: 'dashboard',
  APP_ICONS: 'coreline-dev/app-icons',
  NETWORK: 'check/network',
}

// TODO # APP's sub path
export const appSubPath = {}

// # MGMT's sub path
export const mgmtSubPath = {
  GROUPS: 'groups',
  USERS: 'users',
  DATA: 'data',
  NODES: 'nodes',
  CONFIG: 'config',
  LICENSE: 'license',
  DICOM_SCPS: 'dicomscp',
  DICOM_PEERS: 'dicompeers',
  PACS_QR: 'pacsqr',
  HL7: 'hl7',
  RULE_SETS: 'rulesets',
  USER_SESSION: 'appsession',
  APS_RULE: 'apsrule',
  GATEWAYS: 'gateways',
  AUDIT: 'audit',
  WPS: 'wps'
}

// # Dashboard's sub path
export const dashboardSubPath = {
  OVERVIEW: 'overview',
}

// TODO # WORKLIST's sub path
export const worklistSubPath = {}

// # Default Language Set
export const DEFAULT_LANG = 'en-US'

// # Current release version
export const REALEASED_VERSION = 'v1.0.30.1'

// # Http request header key for authorization
export const HTTP_HEADER_AUTH_KEY = 'Authorization'
export const HTTP_HEADER_IGNORE_INTERCEPTOR = 'IgnoreInterceptor'

// # Cookie name for authorization token
export const AUTH_TOKEN_COOKIE = 'CORELINE_AUTH_TOKEN'
export const APP_CLIENT_KEY_COOKIE = 'CORELINE_APP_CLIENT_KEY'
export const ACCESS_TOKEN = 'ACCESS_TOKEN_COOKIE'

// # Cookie name for keeping logged in cookie flag
export const KEEP_ME_LOGGED_IN_COOKIE = 'KEEP_ME_LOGGED_IN'

// # Key for cached email
export const CACHED_EMAIL = 'CACHED_EMAIL'

// # Default rows per page
export const ROWS_PER_PAGE = [5, 10, 15, 20]

// # Form ID
export const FORM_ID = 'core-form'

// # Common form id for dom access
export const FORM_TRIGGER_ID = 'core-form-trigger'

// # API Version
export const API_VERSION = 'v1'

// # Default Node Capacity
export const DEFAULT_NODE_CAPACITY: Array<NodeCapacityProps> = [
  {
    id: 1,
    score: 4,
    cpu: 4,
    ram: 8,
  },
  {
    id: 2,
    score: 8,
    cpu: 8,
    ram: 16,
  },
  {
    id: 3,
    score: 12,
    cpu: 12,
    ram: 24,
  },
  {
    id: 4,
    score: 16,
    cpu: 16,
    ram: 32,
  },
]

// # User Access Level
export const USER_ACCESS_LEVEL: { [key: string]: UserAccessLevelProps } = {
  AccessLevelUnknown: {
    id: 'AccessLevelUnknown',
    enumValue: 0,
    label: 'Unknown',
  },
  AccessLevelAnonymous: {
    id: 'AccessLevelAnonymous',
    enumValue: 100,
    label: 'Anonymous',
  },
  AccessLevelUsual: {
    id: 'AccessLevelUsual',
    enumValue: 200,
    label: 'Usual',
  },
  AccessLevelAdmin: {
    id: 'AccessLevelAdmin',
    enumValue: 400,
    label: 'Admin',
  },
  AccessLevelSysAdmin: {
    id: 'AccessLevelSysAdmin',
    enumValue: 500,
    label: 'System Admin',
  },
  AccessLevelSystem: {
    id: 'AccessLevelSystem',
    enumValue: 600,
    label: 'System',
  },
}

export const ENUM_USER_ACCESS_LEVEL: { [key: string]: UserAccessLevelProps } = {
  '0': {
    id: 'AccessLevelUnknown',
    enumValue: 0,
    label: 'Unknown',
  },
  '100': {
    id: 'AccessLevelGuest',
    enumValue: 100,
    label: 'Guest',
  },
  '200': {
    id: 'AccessLevelUsual',
    enumValue: 200,
    label: 'Usual',
  },
  '400': {
    id: 'AccessLevelAdmin',
    enumValue: 400,
    label: 'Admin',
  },
  '500': {
    id: 'AccessLevelSysAdmin',
    enumValue: 500,
    label: 'System Admin',
  },
  '600': {
    id: 'AccessLevelSystem',
    enumValue: 600,
    label: 'System',
  },
}

// # DicomScp's Ruleset TYpe
export const RULESET_TYPE = {
  dicomScpRouting: 'STORE',
}

// # 인증 관련 Response err를 handling하기 위한 event name
export const SIGN_ERR_EVENT = {
  DENIED: 'denied',
  WPWINFO: 'wPwinfo',
  WINFO: 'winfo',
  EXPIRED: 'expired',
  DEACTIVATED: 'deactivated',
  ID_NOT_EMPTY: 'idNotEmpty',
  PW_NOT_EMPTY: 'pwNotEmpty',
  SERVER: 'server',
  REQUIRED_PW_RESET: 'required',
  OLDPW: 'isOldPw',
  THO_FACTOR_CODE: 'wTwoFactorCode'
}

// # 인증 관련 Response err code
export const SIGN_ERR_STATUS_CODE: { [key: string]: string } = {
  '101': SIGN_ERR_EVENT.DENIED,
  '400': SIGN_ERR_EVENT.WINFO,
  '401': SIGN_ERR_EVENT.EXPIRED,
  '403': SIGN_ERR_EVENT.DEACTIVATED,
  '409': SIGN_ERR_EVENT.OLDPW,
  '500': SIGN_ERR_EVENT.SERVER,
}

// #
export const CONDITION_RELATION_TYPES = ['AND', 'OR']

// # Idle에서 onAction 메소드 호출 이전까지 Delay 시간 (Milliseconds)
export const IDLE_TO_ACTION_DELAY = 400

// # flag for idle timer on
export const COOKIE_IDLE_TIMER = 'IDLE_TIMER'

// # cookie for saving last active time
export const COOKIE_LAST_ACTIVE_TIME = 'LAST_ACTIVE_TIME'

// #
export const UNKNOWN_USER_NAME = 'Unknown'

// # Original patient search를 질의하는 URL 쿠키 이름
export const COOKIE_PATIENT_SEARCH_URL = 'PATIENT_SEARCH_BASE_URL'

// # 마지막으로 선택된 Study의 Patient ID
export const COOKIE_PATIENT_ID = 'PATIENT_SEARCH_SELECTED_PATIENT_ID'

// # 마지막으로 입력된 Data Token의 값
export const COOKIE_PATIENT_SEARCH_STORAGE_TOKEN = 'PATIENT_SEARCH_DATA_TOKEN'

// To integrate with the havana project
export const HVN_INTEGRATED = 'HVN_INTEGRATED'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [02] Types

// # Snack bar event types
export type SNACK_BAR_EVT = 'error' | 'success' | 'info' | 'warning'

// # Snack bar vertical option types
export type SNACK_BAR_VERT_OPTION = 'top' | 'bottom'

// # Snack bar horizontal option types
export type SNACK_BAR_HORI_OPTION = 'center' | 'right' | 'left'

// # Table header align type
export type TABLE_HEADER_ALIGN_OPTION = 'center' | 'right' | 'left'

// # Sort option
export type SORT_OPTION = 'desc' | 'asc' | undefined

// # Node Props
export type AdvancedNodeProps = {
  importNode: NodeElementProps
  dataNode: NodeElementProps
}

// # User access level code value
export type USER_ACCESS_LEVEL_VALUE = 0 | 100 | 200 | 400 | 500 | 600

export type Day = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday'

export type Validator = {
  validate: (value: any) => Promise<any>;
  eMessage?: string | undefined;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [03] Interfaces

// # Nav menu ( Setting page )
export interface NavMenuProps {
  icon?: () => JSX.Element
  displayText: string
  name: string
  onClick: ReactClickEvent | ReactEmptyEvent
}

// # Sub Page Component's interface
export interface SubPageComponent {
  setDrawerMenus: (menus?: Array<NavMenuProps>) => void
  setActiveSubPath: (pathName: string) => void
}

// # Input validator
export interface InputValidator {
  (value: string | number): [boolean, string?]
}

// # Form validator
export interface FormValidator<T> {
  (value: T): [boolean, string?]
}

// # Input validator on blur
export interface InputBlurValidator {
  (value: string | number | Array<any>): Promise<[boolean, string?]>
}

// # Table pagination event
export interface ReactTablePagination {
  (pageevent: React.MouseEvent<HTMLButtonElement, MouseEvent> | null, page: number): void
}

// # Key base object interface
export interface KeyIndexedObject<T> {
  [key: string]: T
}

// # Get query param
export interface GetQueryParams {
  pageIndex?: number
  pageSize?: number
  order?: SORT_OPTION
  orderBy?: string
  filter?: string
  operand?: 'and' | 'or'
}

// # Get response
export interface GetQueryReturn<T> {
  next_page_index?: string
  total_count?: string
  count?: number
  request?: GetQueryRtnParams
  items?: Array<T>
}

interface GetQueryRtnParams {
  page_index: string
  page_size: number
  order_by: string
  filter: string
}

// # URL Query
export interface UrlQueryProps extends KeyIndexedObject<string | number | SORT_OPTION> { }

// # Management Formatter
export interface TextFormatter<T> {
  (item: T): string | number
}

// # Assigned Item Interface
export interface AssignedItemProps<T> {
  unassigned: Array<T>
  assigned: Array<T>
}

// # Node Capacity
export interface NodeCapacityProps {
  id: number
  cpu: number
  score: number
  ram: number
}

// # User Access Level Interface
export interface UserAccessLevelProps {
  id: string
  enumValue: USER_ACCESS_LEVEL_VALUE
  label: string
}

// #
export interface UILanguageProps {
  id: string
  label: string
}

// #
export interface numericValidatorProps {
  min?: number
  max?: number
  gt?: number
  lt?: number
  range?: string
}

// # [MGMT] Validator Interface
export interface MgmtValidator {
  validator: {
    [key: string]: InputValidator
  }
  blurValidator: {
    [key: string]: InputBlurValidator
  }
}

// [MGMT] Formatter Interface
export interface FormatterProps {
  formatter?: {
    [key: string]: TextFormatter<any>
  }
}

//
export interface APSRuleSelectableProps {
  id: string
  label: string
  fk_data_storage_id?: string
}

// # Database element's time stamp
export interface ElementTimeStampProps {
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [04] Event Interfaces

// # Empty function interface
export interface ReactEmptyEvent {
  (): void
}

// # Input value change Event
export interface ReactInputChangeEvent {
  (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void
}

// # Click event
export interface ReactClickEvent {
  (event: React.MouseEvent<HTMLElement | HTMLButtonElement, MouseEvent>): void
}

// # Input box check event
export interface ReactInputCheckedEvent {
  (event: React.ChangeEvent<any>, checked: boolean): void
}

// # Form action handler
export interface ReactFormEvent {
  (event: React.FormEvent<HTMLFormElement | HTMLInputElement>): void
}

// # Form blur event
export interface ReactBlurEvent {
  (event: React.FocusEvent<HTMLDivElement>): void
}

// # Change Event
export interface ReactChangeWithValue {
  (event: React.ChangeEvent<{}>, value: string): void
}

// # Dialog Close Event
export interface ReactSyntheticEvent {
  (event: React.SyntheticEvent<{}, Event>): void
}

// # Select Event
export interface ReactSelectEvent {
  (event: React.ChangeEvent<{ name?: string; value: any }>, child: React.ReactNode): void
}

// # Keydown Event
export interface ReactKeyDownEvent {
  (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement | HTMLDivElement>): void
}

// # Key Up Event
export interface ReactKeyUpEvent {
  (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement | HTMLDivElement>): void
}

// # Key Press Event
export interface ReactKeyPressEvent {
  (event: React.KeyboardEvent<HTMLDivElement | HTMLInputElement | HTMLTextAreaElement>): void
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// [05] Enums

// # Empty function interface
export enum StopServerReason {
  NEW_SESSION_STARTED = 'NEW_SESSION_STARTED',
  SESSION_ABORTED = 'SESSION_ABORTED',
  USER_LOGOUT = 'USER_LOGOUT',
  FATAL_ERROR = 'FATAL_ERROR',
}
